import { render, staticRenderFns } from "./AddOrderOtherDetail.vue?vue&type=template&id=75606f4a&scoped=true&"
import script from "./AddOrderOtherDetail.vue?vue&type=script&lang=js&"
export * from "./AddOrderOtherDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderOtherDetail.vue?vue&type=style&index=0&id=75606f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75606f4a",
  null
  
)

export default component.exports